import React from 'react';
import { useTheme } from 'styled-components';

const NotificationBellIcon = ({
  size = 25,
  color = '#5D6473',
  isReminder = false,
  strokeWidth = 1.5,
  ...props
}) => {
  const theme = useTheme();
  const stroke = theme?.dark && !isReminder ? theme?.headingColor : color;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 19.693 22.943"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      {...props}
    >
      <path
        className="hover-stroke"
        d="M3.865 18.76V9.89a5.982 5.982 0 1 1 11.963 0v8.87"
        stroke={stroke}
        strokeWidth={strokeWidth}
      />
      <line
        className="hover-stroke"
        x1="0.75"
        y1="18.76"
        x2="18.943"
        y2="18.76"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
      />
      <line
        className="hover-stroke"
        x1="9.846"
        y1="3.905"
        x2="9.846"
        y2="0.75"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
      />
      <line
        className="hover-stroke"
        x1="8.459"
        y1="22.193"
        x2="11.233"
        y2="22.193"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
      />
    </svg>
  );
};

export default NotificationBellIcon;
